import { render, staticRenderFns } from "./FormFieldSwitch.vue?vue&type=template&id=60c05fc6&scoped=true&"
import script from "./FormFieldSwitch.vue?vue&type=script&lang=js&"
export * from "./FormFieldSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldSwitch.vue?vue&type=style&index=0&id=60c05fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c05fc6",
  null
  
)

export default component.exports